import React, { FC, useCallback, useState } from 'react'
import { useController } from 'react-hook-form'
import { Select, InputGroup } from '@wmgtech/legato'

import { CountryBadge } from '..'
import { cn } from 'shared/utils'
import { TOption } from 'shared/types/SelectOptions'
import { CountryCodeAutocompleteProps } from './CountryCodeAutocomplete.props'

import './CountryCodeAutocomplete.scss'

const CountryCodeAutocomplete: FC<CountryCodeAutocompleteProps> = ({ countryOptions, control, rules }) => {
  const [selectValue, setValue] = useState('')
  const {
    field,
    fieldState: { error }
  } = useController({
    name: 'country_codes',
    control,
    rules
  })

  const onInputChange = useCallback(
    (list: any, value: string) => {
      setValue(value)
      return value
        ? countryOptions.filter((el: TOption) => el.title.toLowerCase().includes(value.toLowerCase()))
        : countryOptions
    },
    [countryOptions]
  )

  const onSelect = useCallback(
    (option: any) => {
      if (!field.value.includes(option.key)) {
        field.onChange([...field.value, option.key])
      }
    },
    [field]
  )

  const onClear = useCallback(
    (value: string) => {
      field.onChange(field.value.filter((el: string) => el !== value))
    },
    [field]
  )

  return (
    <>
      <InputGroup
        className={cn('form-input-group form-input-group__autocomplete', { 'form-input-group__error': error })}
        label="Chart Countries"
        labelProps={{ icon: 'asterisk' }}
        {...(error?.ref?.name && {
          validation: {
            message: error?.message,
            ...(error && { type: 'error' })
          }
        })}
      >
        <Select
          name="country_codes"
          value={selectValue}
          isFilterable
          list={countryOptions}
          getTitle={({ title }) => title}
          getKey={({ key }) => key}
          onSelect={onSelect}
          onFilter={onInputChange}
          placeholder="Country Code"
          searchInputPlaceholder="Type Country Code"
          validation={{
            message: error?.message,
            ...(error && { type: 'error' })
          }}
        />
      </InputGroup>
      <div className="country_badge-list">
        {field.value.map((value: string) => (
          <CountryBadge text={value} key={value} onClear={onClear} />
        ))}
      </div>
    </>
  )
}

export default CountryCodeAutocomplete
